import { Toggle } from "@aisquare/ui";
import { BoldIcon, ItalicIcon, UnderlineIcon } from "lucide-react";
import { Section, VariantBlock } from "../lib/Section";

export function ToggleDemo() {
  return (
    <Section
      id="toggle"
      title="Toggle"
      description="Pressable on/off control in the Onyx notch language — hex-notch silhouette + nx-rim keyline, springy 1px press-DOWN, --accent fill when on. Inline toolbar affordances."
    >
      <VariantBlock label="Variants">
        <Toggle aria-label="Bold (default)">
          <BoldIcon />
        </Toggle>
        <Toggle variant="outline" aria-label="Bold (outline)">
          <BoldIcon />
        </Toggle>
      </VariantBlock>

      <VariantBlock label="Sizes">
        <Toggle size="sm" aria-label="Bold (sm)">
          <BoldIcon />
        </Toggle>
        <Toggle size="default" aria-label="Bold (default)">
          <BoldIcon />
        </Toggle>
        <Toggle size="lg" aria-label="Bold (lg)">
          <BoldIcon />
        </Toggle>
      </VariantBlock>

      <VariantBlock label="States">
        <Toggle aria-label="off">
          <ItalicIcon />
        </Toggle>
        <Toggle pressed aria-label="on">
          <ItalicIcon />
        </Toggle>
        <Toggle disabled aria-label="disabled">
          <UnderlineIcon />
        </Toggle>
        <Toggle pressed disabled aria-label="disabled, pressed">
          <UnderlineIcon />
        </Toggle>
      </VariantBlock>

      <VariantBlock label="With label">
        <Toggle>
          <BoldIcon />
          Bold
        </Toggle>
      </VariantBlock>
    </Section>
  );
}
